/**
 * Sync localStorage progress to Supabase database
 * This ensures existing user progress is saved to the database
 */

import { supabase } from '../supabase';

export const syncLocalStorageToDatabase = async () => {
  try {
    // Get current user
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
      console.log('No user logged in, skipping sync');
      return;
    }

    console.log('Starting progress sync for user:', user.email);

    // Get localStorage data
    const progressKey = 'userProgress';
    const quizProgressKey = 'quizProgress';
    
    const existingProgress = localStorage.getItem(progressKey);
    const existingQuizProgress = localStorage.getItem(quizProgressKey);
    
    if (!existingProgress && !existingQuizProgress) {
      console.log('No localStorage data to sync');
      return;
    }

    const progress = existingProgress ? JSON.parse(existingProgress) : {
      completedLessons: [],
      totalXP: 0,
      streak: 0
    };

    const quizProgress = existingQuizProgress ? JSON.parse(existingQuizProgress) : {};

    console.log('LocalStorage progress:', progress);
    console.log('LocalStorage quiz progress:', quizProgress);

    // 1. Sync user stats to public.users table
    const { error: userError } = await supabase
      .from('users')
      .upsert({
        id: user.id,
        email: user.email,
        display_name: user.user_metadata?.full_name || user.email?.split('@')[0],
        streak: progress.streak || 0,
        xp: progress.totalXP || 0,
        last_login: new Date().toISOString(),
        level_recommended: 'A1'
      }, {
        onConflict: 'id'
      });

    if (userError) {
      console.error('Error syncing user stats:', userError);
    } else {
      console.log('✅ User stats synced to database');
    }

    // 2. DON'T sync old quiz attempts from localStorage
    // This prevents old quizzes from appearing as "completed this week"
    // which would make weekly XP higher than total XP
    // New quiz attempts will be saved directly when completed (in QuizScreen)
    console.log('ℹ️ Skipping quiz attempts sync to prevent timestamp issues');

    console.log('✅ Progress sync complete!');
    return true;
  } catch (error) {
    console.error('Error syncing progress:', error);
    return false;
  }
};

